import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SingleFamilyEnterpriseActions from '../actions/SingleFamilyEnterpriseActions';
import ErrorMessageConstants from '../constants/ErrorMessageConstants';
import { UserSelectors } from '../selectors';

import type { Dispatch } from 'react';
import type { ListingErrorsReducerProps, ListingReducerProps } from '../reducers/listing';

const useContracts = (
  setListing: Dispatch<{ type: keyof ListingReducerProps; payload: unknown }>,
  setErrorObj: Dispatch<ListingErrorsReducerProps>,
  setIsSubmitDisabled: (value: boolean) => void,
) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => UserSelectors.makeUser(state));
  const shouldGetSFContracts = user.isSingleFamilyEnterpriseCustomer && user.userManagementCompanyId;

  useEffect(() => {
    if (shouldGetSFContracts) {
      setIsSubmitDisabled(true);
      dispatch(SingleFamilyEnterpriseActions.getContracts())
        // @ts-expect-error
        .then((newContracts: Array<{ customerId: string }>) => {
          setIsSubmitDisabled(false);
          if (newContracts.length === 1) {
            setListing({
              type: 'customerId',
              payload: newContracts[0].customerId,
            });
          }
        })
        .catch(() => {
          setIsSubmitDisabled(true);
          const errorMessage = ErrorMessageConstants.SINGLE_FAMILY_CANNOT_RETRIEVE_CONTRACTS;
          setErrorObj({ type: 'customerId', payload: errorMessage });
        });
    }
  }, [user]);
};

export default useContracts;
